/** Signed decimal; `,` or `.` separator; leading/trailing separator allowed while typing. */
const COORDINATE_PATTERN = /^-?(\d+([.,]\d*)?|[.,]\d+)$/;

/**
 * Parses free-text coordinate input from a text field.
 *
 * Mobile keyboards in the `nl` locale emit `,` as decimal separator, which a
 * `type="number"` input reports as an empty value — so we accept both `,` and `.`
 * (and the Unicode minus `−`). Returns `undefined` for empty, partial (`-`, `.`)
 * or otherwise invalid input so callers can keep the draft without committing.
 */
export function parseCoordinateInput(raw: string): number | undefined {
  const normalized = raw.trim().replace("\u2212", "-");
  if (!COORDINATE_PATTERN.test(normalized)) return undefined;
  const n = Number(normalized.replace(",", "."));
  return Number.isFinite(n) ? n : undefined;
}

/**
 * Steps a coordinate by `delta` (arrow keys), rounded to 3 decimals to avoid float
 * drift (`52.1 + 0.1 = 52.2`, not `52.200000000000003`) and clamped to `[min, max]`.
 */
export function stepCoordinate(value: number, delta: number, min: number, max: number) {
  const next = Math.round((value + delta) * 1_000) / 1_000;
  return Math.min(max, Math.max(min, next));
}
